const salary = {
  methods: {
    save_ () {
      if (this.$refs.SaveForm.validate()) {
        this.$store.dispatch('saveData', { page: 5, data: { subpage: 3, ...this.selected }, item: this.id })
      }
    },
    delete_ (item) {
      this.$store.dispatch('setOverlay', true)
      this.$dialog.confirm({
        text: this.lang.financial.salary.dialog.delete(item.title),
        title: this.lang.confirm.title,
        waitForResult: true
      }).then(res => {
        this.$store.dispatch('setOverlay', false)
        if (res) {
          this.$store.dispatch('saveMixed', { page: 5, type: 1, data: { subpage: 3, ...item }, ignoreResponseBar: false })
        }
      })
    }
  }
}
export default salary
